import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const pdfSchema = new schema.Entity('pdfContainer', {
    pdfs: [schemas.pdfs]
});
